import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AttributeComponent } from '../../interfaces/attribute.component';
import { AttributeDefinition } from '../../models/attribute-definition';
import { FormControl, FormGroup } from '@angular/forms';
import { LookupListItem } from '../../models/lookup-list-item';
import { AttributeControlService } from '../../attribute-control-service';
import { LookupService } from 'src/app/services/lookup.service';
import { ActivatedRoute } from '@angular/router';
import { TokenHelper } from 'src/app/services/helpers/token.helper';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, AttributeComponent {
  @Input() formGroup: FormGroup;
  @Input() attributeDefinition: AttributeDefinition;

  @Output() onRemove = new EventEmitter<number>();

  options: LookupListItem[] = [];

  constructor(
    private lookup: LookupService,
    public _attributeControlService: AttributeControlService<number>,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const initial =
      this.attributeDefinition.value == null
        ? null
        : Number(String(this.attributeDefinition.value).trim());
    const normalized = Number.isFinite(initial as number) ? (initial as number) : null;

    this._attributeControlService.addFormControl(
      this.attributeDefinition.formControlName,
      this.attributeDefinition.isRequired,
      normalized,
      this.formGroup
    );

    const listId = this.attributeDefinition.attributeLookupListId;
    if (listId) {
      const token = TokenHelper.getToken(this.activatedRoute);
      this.lookup.getResourceAttributeLookupValues(token, listId).subscribe({
        next: (rows) => (this.options = rows.map(LookupListItem.fromDto)),
        error: () => (this.options = [])
      });
    }
  }

  get control(): FormControl {
    return this.formGroup.get(this.attributeDefinition.formControlName) as FormControl;
  }

  get label(): string {
    return (this.attributeDefinition?.name || '').replace(/\s*[:*]+$/, '').trim();
  }

  getErrorMessage(): string {
    if (!this.control) return '';
    if (this.control.hasError('required')) return `${this.label} is required.`;
    return '';
  }

  value(): number | null {
    const raw = this.control?.value;
    const n = raw == null ? null : Number(String(raw).trim());
    const normalized = n != null && Number.isFinite(n) ? n : null;
    this.attributeDefinition.value = normalized;
    return normalized;
  }

  clear(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.control.setValue(null, { emitEvent: true });
    this.control.markAsDirty();
    this.control.markAsTouched();
    this.attributeDefinition.value = null;
  }

  ngOnDestroy(): void {
    this._attributeControlService.removeControl(this.attributeDefinition.formControlName, this.formGroup);
  }
}
